import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  step: 1,
  chosenType: null,
  monthRecurrence: null,
  isLogged: false,
  userId: null,
  thirdPartyAlreadySetup: false,
  globalInformations: {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    phone: ''
  },
  shippingInformations: {
    shipping: {
      address: '',
      complement: '',
      postalCode: '',
      city: ''
    },
    billing: {
      address: '',
      complement: '',
      postalCode: '',
      city: ''
    }
  },
  paymentInformations: {
    creditCardNumber: '',
    monthValidation: '',
    yearValidation: '',
    validationCode: ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
